<template>
  <v-timeline-item
    dot-color="leadActivity"
    icon="mdi-frequently-asked-questions"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      variant="accordion"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row
            no-gutters
            align="center"
            class="d-flex justify-center"
            :class="{ 'flex-column': $vuetify.display.smAndDown }"
          >
            <v-col md="8">
              <div class="mb-2 text-subtitle-1">
                {{ $t('lead-timeline.quizzard.title', { landingpageName }) }}
              </div>
              <div class="text-grey">{{ $t('lead-timeline.quizzard.subtitle') }}: {{ result }}</div>
            </v-col>
            <v-col
              class="pr-2 text-right text-grey"
              :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-list density="compact">
            <v-list-item
              v-for="{ question, answer, screenId } in answers"
              :key="screenId"
              class="pa-0"
              density="compact"
            >
              <v-list-item-title class="text-wrap">
                {{ question }}
              </v-list-item-title>
              <div class="text-grey text--darken-3 text-body-2 text-wrap">
                {{ answer }}
              </div>
            </v-list-item>
          </v-list>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>

<script>
import QuizPreConversion from '../queries/QuizPreConversion.gql'

export default {
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    landingpageName() {
      return this.quizPreConversion?.landingpage?.name ?? ''
    },
    result() {
      return this.quizPreConversion?.details?.result ?? ''
    },
    answers() {
      return this.quizPreConversion?.details?.answers ?? ''
    },
  },
  apollo: {
    quizPreConversion: {
      query: QuizPreConversion,
      variables() {
        return {
          preConversionId: this.data.details[this.data.type].preConversionId,
        }
      },
    },
  },
}
</script>

<style scoped>
.expansion-panels {
  margin: -24px -24px 0 -24px;
}
</style>
